import React from 'react'
import howItWorksImg from "../../../../../assets/images/bookPage/how-it-works.png";

export const HowItWorks = (props) => {
  const defaultItems = [
    {
      title: 'Book Online',
      description: 'Schedule your shoot in minutes and keep control of your listings without the back-and-forth.'
    },
    {
      title: 'On-Site Photography',
      description: 'Photographer arrives, prepared to create a winning game plan to capture your property at its best.'
    },
    {
      title: 'Next Day Media Delivery',
      description: 'Receive your pro photos, videos and tours next day, with instant download notifications straight to your inbox.'
    }
  ]

  const subtitle = props.subtitle || "From booking to delivery, we're with you every step of the way."
  const items = props.items || defaultItems

  return <div className="how-it-works-container">
    <div className="how-it-works-container-inner book-page-container-inner">
      <div className="how-it-works-content">
        <div className="how-it-works-subtitle">Our process</div>
        <div className="how-it-works-title">How it works..</div>
        <div className="how-it-works-description">{subtitle}</div>

        <div className="how-it-works-list">
          {items.map((item, i) => (
            <div className="how-it-works-list-item" key={`how-it-works-${i}`}>
              <div className="how-it-works-list-item-count">{i + 1}</div>
              <div className="how-it-works-list-item-text">
                <div className="how-it-works-list-item-title">{item.title}</div>
                <div className="how-it-works-list-item-description">{item.description}</div>
              </div>
            </div>))}
        </div>
      </div>

      <div className="how-it-works-image">
        <img src={howItWorksImg}/>
      </div>
    </div>
  </div>
}